import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Header from '../header/header';
import Footer from '../footer/footer';
export default function Layout({ children }) {
  const data = useStaticQuery(
    graphql`
      query {
        allSite {
        nodes {
          siteMetadata {
            title
          }
        }
      }
    }
    `)
  return (
    <div id="container">
      <Header headerText={data.allSite.nodes[0].siteMetadata.title}></Header>
      {children}
      <Footer></Footer>
    </div>
  )
}